import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bot } from '../../services/adminApiService';
import './BotSelector.css';

interface BotSelectorProps {
  bots: Bot[];
  selectedBotId: string | null;
  onBotSelect: (botId: string) => void;
  loading?: boolean;
  error?: string | null;
}

const BotSelector: React.FC<BotSelectorProps> = ({
  bots,
  selectedBotId,
  onBotSelect,
  loading = false,
  error = null,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="bot-selector">
        <label className="bot-selector-label">{t('botSelector.label')}:</label>
        <select className="bot-selector-dropdown" disabled>
          <option>{t('botSelector.loading')}</option>
        </select>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bot-selector">
        <label className="bot-selector-label">{t('botSelector.label')}:</label>
        <div className="bot-selector-error">{error}</div>
      </div>
    );
  }

  if (bots.length === 0) {
    return (
      <div className="bot-selector">
        <label className="bot-selector-label">{t('botSelector.label')}:</label>
        <div className="bot-selector-empty">{t('botSelector.noBots')}</div>
      </div>
    );
  }

  return (
    <div className="bot-selector">
      <label className="bot-selector-label" htmlFor="bot-select">
        {t('botSelector.label')}:
      </label>
      <select
        id="bot-select"
        className="bot-selector-dropdown"
        value={selectedBotId || ''}
        onChange={(e) => onBotSelect(e.target.value)}
      >
        {bots.map((bot) => (
          <option key={bot.botId} value={bot.botId}>
            {bot.botName || bot.botId}
          </option>
        ))}
      </select>
    </div>
  );
};

export default BotSelector;
